'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var components_Body2_index = require('../Body2/index.js');
var components_SvgIcon_index = require('../SvgIcon/index.js');
var components_Subheader1_index = require('../Subheader1/index.js');
var help = require('../../help-ecea67e1.js');
var exclamationMark = require('../../exclamation-mark-8535f548.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.39 22.78a9.978 9.978 0 0 0 4.013-.813 10.593 10.593 0 0 0 3.308-2.245 10.503 10.503 0 0 0 2.256-3.308c.542-1.258.813-2.6.813-4.024a9.84 9.84 0 0 0-.824-4.002A10.468 10.468 0 0 0 19.7 5.069a10.504 10.504 0 0 0-3.308-2.256A9.98 9.98 0 0 0 12.379 2a9.952 9.952 0 0 0-4.002.813 10.633 10.633 0 0 0-5.564 5.575A9.953 9.953 0 0 0 2 12.39c0 1.424.271 2.766.813 4.024a10.75 10.75 0 0 0 2.256 3.308 10.593 10.593 0 0 0 3.308 2.245 9.978 9.978 0 0 0 4.013.813Zm0-1.573a8.686 8.686 0 0 1-3.438-.683 8.844 8.844 0 0 1-2.798-1.887 8.974 8.974 0 0 1-1.887-2.809 8.686 8.686 0 0 1-.684-3.438 8.58 8.58 0 0 1 .684-3.416 8.811 8.811 0 0 1 1.887-2.81 8.756 8.756 0 0 1 2.798-1.897 8.607 8.607 0 0 1 3.427-.684c1.23 0 2.375.228 3.438.684a8.756 8.756 0 0 1 2.798 1.898 8.724 8.724 0 0 1 1.898 2.809 8.58 8.58 0 0 1 .684 3.416 8.554 8.554 0 0 1-.673 3.438 8.883 8.883 0 0 1-1.898 2.809 8.81 8.81 0 0 1-2.809 1.887 8.608 8.608 0 0 1-3.427.683Zm-1.128-3.947c.311 0 .56-.149.748-.445l4.805-7.527c.058-.094.108-.191.152-.293a.674.674 0 0 0 .076-.303.586.586 0 0 0-.239-.488.805.805 0 0 0-.52-.196c-.253 0-.47.141-.651.423l-4.403 7.017-2.159-2.733a.917.917 0 0 0-.325-.293.862.862 0 0 0-.369-.075.675.675 0 0 0-.51.216.706.706 0 0 0-.206.521c0 .195.073.39.217.586l2.592 3.145c.123.159.246.275.37.347a.89.89 0 0 0 .422.098Z",
    fill: "#000"
  })));
};

var Container = styled__default["default"].div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  border-radius: 6px;\n  background-color: ", ";\n  padding: 16px 16px 16px 20.9px;\n  display: flex;\n  align-items: center;\n"], ["\n  border-radius: 6px;\n  background-color: ", ";\n  padding: 16px 16px 16px 20.9px;\n  display: flex;\n  align-items: center;\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    switch (variant) {
        case constants_properties.CalloutVariant.INFO:
            return theme.colors.background.secondary;
        case constants_properties.CalloutVariant.DANGER:
            return theme.colors.background.negative;
        case constants_properties.CalloutVariant.WARNING:
            return theme.colors.background.warning;
        case constants_properties.CalloutVariant.SUCCESS:
            return theme.colors.background.positive;
        default:
            return theme.colors.background.secondary;
    }
});
var Content = styled__default["default"](components_Body2_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  line-height: 18px;\n"], ["\n  color: ", ";\n  line-height: 18px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text.primary;
});
var QuestionIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: help.SvgHelp,
    size: constants_properties.SvgIconSize.MEDIUM,
    fill: constants_properties.SvgIconColor.PRIMARY,
})(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-right: 20.91px;\n  margin-top: 4px;\n  align-self: flex-start;\n"], ["\n  margin-right: 20.91px;\n  margin-top: 4px;\n  align-self: flex-start;\n"])));
var ExclamationIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: exclamationMark.SvgExclamationMark,
    size: constants_properties.SvgIconSize.MEDIUM,
    fill: constants_properties.SvgIconColor.PRIMARY,
})(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  margin-right: 20.91px;\n  margin-top: 4px;\n  align-self: flex-start;\n"], ["\n  margin-right: 20.91px;\n  margin-top: 4px;\n  align-self: flex-start;\n"])));
var CheckIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    icon: SvgCheckCircle,
    size: constants_properties.SvgIconSize.MEDIUM,
    fill: constants_properties.SvgIconColor.PRIMARY,
})(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  margin-right: 20.91px;\n  margin-top: 4px;\n  align-self: flex-start;\n"], ["\n  margin-right: 20.91px;\n  margin-top: 4px;\n  align-self: flex-start;\n"])));
var ContentContainer = styled__default["default"].div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var CalloutTitle = styled__default["default"](components_Subheader1_index["default"])(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  margin-bottom: 4px;\n  color: ", ";\n"], ["\n  margin-bottom: 4px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text.primary;
});
var ActionLink = styled__default["default"](components_Body2_index["default"])(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  cursor: pointer;\n  color: ", ";\n  margin-top: 8px;\n"], ["\n  cursor: pointer;\n  color: ", ";\n  margin-top: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text.link;
});
function determineIcon(variant) {
    switch (variant) {
        case constants_properties.CalloutVariant.INFO:
            return React__namespace.createElement(QuestionIcon, null);
        case constants_properties.CalloutVariant.SUCCESS:
            return React__namespace.createElement(CheckIcon, null);
        default:
            return React__namespace.createElement(ExclamationIcon, null);
    }
}
var Callout = function (_a) {
    var content = _a.content, customContent = _a.customContent, _b = _a.hideIcon, hideIcon = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? constants_properties.CalloutVariant.INFO : _c, title = _a.title, action = _a.action, className = _a.className;
    return (React__namespace.createElement(Container, { className: className, variant: variant },
        !hideIcon && determineIcon(variant),
        customContent ? (customContent) : (React__namespace.createElement(ContentContainer, null,
            title && React__namespace.createElement(CalloutTitle, null, title),
            React__namespace.createElement(Content, null, content),
            (action === null || action === void 0 ? void 0 : action.text) && (React__namespace.createElement(ActionLink, { onClick: function () { return action.actionFunction(); } }, action.text))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

exports["default"] = Callout;
